<template>
  <v-layout class="grey lighten-4" column>
    <div class="noto bold primary--text pa-3 d-md-flex align-center" width="100%">
      <div class="title primery--text">Configuración de {{ $store.state.currentRestaurant.data.name }}</div>
    </div>

    <v-flex xs12>
      <v-row justify="center">
        <v-col md="10">
          <v-row>
            <v-col
              v-if="query"
              cols="12">
              <v-alert
                v-model="alert.active"
                close-text="Close Alert"
                :color="alert.color"
                dark
                dismissible
              >
                {{ alert.message }}
              </v-alert>
            </v-col>
            <v-col cols="12">
              <v-card flat tile>
                <v-card-title v-if="restaurantPermissions['social-network']">
                  <v-row>
                    <v-col>
                      Redes sociales
                    </v-col>
                  </v-row>
                </v-card-title>
                <v-card-text v-if="restaurantPermissions['social-network']">
                  <v-form>
                    <v-row>
                      <v-col cols="12">
                        Conéctate a estas redes sociales para obtener mejores reportes:
                      </v-col>
                      <v-col md="12">
                        <div class="d-flex">
                          <v-btn
                            rounded
                            small
                            depressed
                            :color="social.facebook.color"
                            class="white--text"
                            :href="connectSocialNetwork('facebook')"
                            >
                            Conéctate con Facebook
                          </v-btn>
                          <v-btn
                            rounded
                            small
                            depressed
                            :color="social.foursquare.color"
                            class="white--text ml-2"
                            :href="connectSocialNetwork('foursquare')"
                            >
                            Conéctate con Foursquare
                          </v-btn>
                        </div>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12">
              <v-card flat tile v-if="restaurantPermissions['change-restaurant-information']">
                <v-card-title>
                  <v-row>
                    <v-col>
                      Datos del restaurante
                    </v-col>
                  </v-row>
                </v-card-title>
                <v-card-text>
                  <v-form  v-model="form.restaurantInformation.valid" ref="restaurantInfoForm">
                    <v-row>
                      <v-col cols="12">
                        Perfil del restaurante
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          dense
                          rounded
                          outlined
                          hide-details
                          label="Nombre del restaurante"
                          :rules="rules.name"
                          maxlength="64"
                          v-model="form.restaurantInformation.name"/>
                      </v-col>
                      <v-col cols="12 d-flex align-center">
                        <div style="width: 100%">
                          <v-file-input
                            class="mr-3"
                            dense
                            rounded
                            outlined
                            hide-details
                            accept=".png, .jpg"
                            label="Logo del restaurante (imagen de 120px x 120px)"
                            v-model="restaurantInformation.picture"/>
                          <span
                            v-if="form.restaurantInformation.picture && form.restaurantInformation.picture.name"
                            class="primary--text">
                            {{ form.restaurantInformation.picture.name }}
                          </span>
                        </div>
                        <v-avatar
                          color="primary"
                          size="80">
                          <img
                            v-if="form.restaurantInformation.picture && form.restaurantInformation.picture.location"
                            :src="form.restaurantInformation.picture.location"/>
                        </v-avatar>
                        <v-divider/>
                      </v-col>
                      <v-col cols="12">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              dense
                              rounded
                              outlined
                              :rules="rules.nip"
                              hide-details
                              label="NIP"
                              placeholder="Genera un NIP para firmar recepción de mercancías."
                              v-on="on"
                              maxlength="15"
                              :append-icon="showNip ? 'mdi-eye' : 'mdi-eye-off'"
                              :type="showNip ? 'text' : 'password'"
                              v-model="form.restaurantInformation.nip"
                              @click:append="showNip = !showNip"/>
                          </template>
                          <span>
                            Este NIP te servirá como firma para recibir tu mercancía.
                          </span>
                        </v-tooltip>
                      </v-col>
                      <v-col class="d-flex justify-center" cols="12">
                        <v-btn
                          rounded
                          small
                          depressed
                          color="primary"
                          :disabled="!form.restaurantInformation.valid"
                          @click="saveRestaurantInfo">
                          Guardar datos del restaurant
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-col>
            <!-- <v-col cols="12"> -->
              <!-- <v-card flat tile v-if="restaurantPermissions['purchase-orders-notification']">
                <v-card-title>
                  <v-row>
                    <v-col>
                      Notificaciones de órdenes de compra
                    </v-col>
                    <v-col class="d-flex justify-end">
                      <v-btn
                        rounded
                        small
                        depressed
                        color="primary"
                        @click="openAddPhoneNumberModal">
                        Agregar número de teléfono
                      </v-btn>
                      <AddPhoneNumber :id="restaurant.id" ref="addPhoneNumber" @updated="get"/>
                    </v-col>
                  </v-row>
                </v-card-title>
                <v-card-text>
                  <div class="subtitle">
                    Agrega tu lista de números telefónicos a los que quieras que le llegen notificaciones por WhatsApp de las actualizaciones de órdenes de comrpra.
                  </div>
                  <v-row>
                    <v-col cols="12">
                      <v-list-item
                        v-for="(phone, index) in restaurant.phoneList"
                        :key="`phone-${index}`">
                        <v-list-item-icon>
                          <v-icon color="green">mdi-whatsapp</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>{{ phone.code }}{{ phone.number }}</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                          <div class="d-flex align-center">
                            <v-btn
                              v-if="phone.status === 'pending'"
                              @click="openVerifyNumberModal(phone)"
                              text>
                              <v-icon
                                left
                                size="small">
                                mdi-alert
                              </v-icon>
                              Verificar teléfono
                            </v-btn>

                            <div v-else class="green--text mr-3">
                              <v-icon color="green">
                                mdi-check
                              </v-icon>
                              Número verificado
                            </div>

                            <v-btn
                              fab
                              x-small
                              depressed
                              @click="openDeleteNumber(phone)"
                              color="red">
                              <v-icon
                                color="white"
                                size="small">
                                mdi-delete
                              </v-icon>
                            </v-btn>
                          </div>
                        </v-list-item-action>
                      </v-list-item>

                      <VerifyNumber ref="verifyNumber" :phone="phoneSelected" @updated="get"/>
                      <DeleteNumber ref="deleteNumber" :phone="phoneSelected" :id="restaurant.id"/>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card> -->
            <!-- </v-col> -->
            <v-col cols="12">
              <v-card flat tile v-if="restaurantPermissions['change-restaurant-tax-information']">
                <v-card-title>
                  <v-row>
                    <v-col>
                      Datos fiscales
                    </v-col>
                  </v-row>
                </v-card-title>
                <v-card-text>
                  <v-form v-model="taxInformationFormValid" ref="taxInformationForm">
                    <v-row>
                      <v-col cols="12">
                        <v-text-field
                          dense
                          rounded
                          outlined
                          hide-details
                          :rules="rules.taxName"
                          label="Nombre fiscal"
                          @input="form.taxInformation.taxName = form.taxInformation.taxName.toUpperCase()"
                          @change="deleteAccents(form.taxInformation.taxName)"
                          v-model="form.taxInformation.taxName"/>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          dense
                          rounded
                          outlined
                          hide-details
                          :rules="rules.taxId"
                          label="RFC"
                          @input="form.taxInformation.taxId = form.taxInformation.taxId.toUpperCase()"
                          v-model="form.taxInformation.taxId"/>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          dense
                          rounded
                          outlined
                          hide-details
                          :rules="rules.zipCode"
                          label="Código postal"
                          maxlength="5"
                          v-model="form.taxInformation.address.zipCode"/>
                      </v-col>
                      <v-col cols="12">
                        <v-autocomplete
                          v-model="form.taxInformation.address.country"
                          label="País"
                          placeholder="MX"
                          :items="countrycodes"
                          :filter="searchCode"
                          item-text="name"
                          item-value="code"
                          dense
                          rounded
                          hide-details
                          outlined
                          :rules="rules.country"/>
                      </v-col>
                      <v-col cols="12">
                        <v-select
                          dense
                          rounded
                          outlined
                          hide-details
                          :items="taxRegimes"
                          item-text="name"
                          item-value="satId"
                          :rules="rules.taxRegime"
                          label="Regimen Fiscal"
                          v-model="form.taxInformation.fiscalRegime">
                          <template v-slot:item="{ item }">
                            {{ item.satId }} | {{ item.name }}
                          </template>
                        </v-select>
                      </v-col>
                    </v-row>
                    <v-divider/>
                    <v-row>
                      <v-col cols="12">
                        <v-row>
                          <v-col cols="12">
                            <div class="my-3">
                              <b>Firma electrónica FIEL/eFirma</b>
                            </div>
                            <div>
                              Necesitarás subir el <b>certificado</b> que es el archivo con terminación <b>".cer"</b> y la <b>llave privada</b> que es el archivo con terminación <b>".key"</b> de tu <b>Firma Electrónica FIEL</b>.
                            </div>
                            <div>
                              Para más información <a href="https://www.sat.gob.mx/tramites/16703/obten-tu-certificado-de-e.firma-(antes-firma-electronica)#:~:text=A-,%C2%BFQu%C3%A9%20es%20la%20e.firma%20(antes%20Firma%20electr%C3%B3nica)%3F,Municipios%20y%20la%20iniciativa%20privada." target="_blank">haz click aquí</a>.
                            </div>
                          </v-col>
                          <v-col cols="12">
                            <v-file-input
                              dense
                              rounded
                              outlined
                              hide-details
                              accept=".cer"
                              label="Certificado FIEL"
                              v-model="form.taxInformation.firmCertificateFile"/>
                          </v-col>
                          <v-col cols="12">
                            <v-file-input
                              dense
                              rounded
                              outlined
                              hide-details
                              accept=".key"
                              label="Private key FIEL"
                              v-model="form.taxInformation.firmPrivateKeyFile"/>
                          </v-col>
                          <v-col cols="12">
                            <v-text-field
                              dense
                              rounded
                              outlined
                              hide-details
                              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                              :type="showPassword ? 'text' : 'password'"
                              label="Password FIEL"
                              v-model="form.taxInformation.firmPrivateKeyPassword"
                              @click:append="showPassword = !showPassword"
                            />
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col class="d-flex justify-center" cols="12">
                        <v-btn
                          rounded
                          small
                          depressed
                          color="primary"
                          @click="saveTaxInformation">
                          Guardar datos fiscales del restaurant
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12">
              <v-card flat tile v-if="restaurantPermissions['change-restaurant-information']">
                <v-card-title>
                  <v-row>
                    <v-col>
                      Dirección del local o ubicación del restaurante
                    </v-col>
                  </v-row>
                </v-card-title>
                <v-card-text>
                  <div>
                    Ingresa en el formulario la dirección del restaurante para ubicarlo en el mapa, posterior a ello guarda los cambios. (Si el marcador no se encuentra en el lugar exacto, puedes moverlo a la dirección donde se encuentra el restaunte)
                  </div>
                  <v-form>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field
                          dense
                          rounded
                          outlined
                          hide-details
                          label="Calle"
                          v-model="form.restaurantInformation.address.street"/>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                          dense
                          rounded
                          outlined
                          hide-details
                          label="Número interior"
                          v-model="form.restaurantInformation.address.interior"/>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                          dense
                          rounded
                          outlined
                          hide-details
                          label="Número exterior"
                          v-model="form.restaurantInformation.address.exterior"/>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                          dense
                          rounded
                          outlined
                          hide-details
                          label="Colonia"
                          v-model="form.restaurantInformation.address.neighborhood"/>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                          dense
                          rounded
                          outlined
                          hide-details
                          label="Ciudad"
                          v-model="form.restaurantInformation.address.city"/>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                          dense
                          rounded
                          outlined
                          hide-details
                          label="Estado"
                          v-model="form.restaurantInformation.address.state"/>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                          dense
                          rounded
                          outlined
                          hide-details
                          label="Código Postal"
                          maxlength="5"
                          v-model="form.restaurantInformation.address.zipCode"/>
                      </v-col>
                      <v-col class="d-flex justify-center" cols="12">
                        <div>
                          <v-btn
                            class="ma-1"
                            rounded
                            small
                            depressed
                            color="primary"
                            @click="geocodeAddress">
                            Ubicar restaurante en el mapa
                          </v-btn>
                        </div>
                        <div>
                          <v-btn
                            class="ma-1"
                            rounded
                            small
                            depressed
                            color="secondary"
                            :disabled="!enableSaveLocation"
                            @click="updateMarker">
                            Guardar Ubicación
                          </v-btn>
                        </div>
                      </v-col>
                      <v-col cols="12">
                        <div id="map" ref="map" style="width:100%;  height: 400px;"></div>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12">
              <v-card flat tile v-if="restaurantPermissions['delivery-address']">
                <v-card-title>
                  <v-row>
                    <v-col>
                      Direcciones de entrega de mercancía
                    </v-col>
                    <v-col class="d-flex justify-end">
                      <v-btn
                        fab
                        x-small
                        depressed
                        color="primary"
                        @click="deliveryDialog=true">
                        <v-icon>mdi-plus</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-title>
                <v-card-text>
                  <div class="ma-2">
                    <b>Agrega una ubicación o más, para que tus proveedores sepan en dónde deben de entregar la mercancía. (Estable una dirección por defecto)</b>
                  </div>
                  <v-divider/>
                  <v-list-item
                    v-for="(item, index) in form.restaurantInformation.deliveryAddresses"
                    :key="item._id"
                  >
                    <v-list-item-avatar>
                      <v-icon v-if="!item.isDefault" class="grey lighten-1" dark>mdi-pin</v-icon>
                      <v-icon v-else class="blue lighten-1" dark>mdi-pin</v-icon>
                    </v-list-item-avatar>

                    <v-list-item-content>
                      <v-list-item-title v-text="item.address"></v-list-item-title>
                      <v-list-item-subtitle v-text="item.schedule"></v-list-item-subtitle>
                      <v-list-item-subtitle v-text="item.receiver"></v-list-item-subtitle>
                      <v-list-item-subtitle v-text="item.comments"></v-list-item-subtitle>
                    </v-list-item-content>

                    <v-list-item-action>
                      <v-btn
                        fab
                        x-small
                        depressed
                        color="primary"
                        @click="updateDelivery(item)">
                        <v-icon color="white">mdi-pencil</v-icon>
                      </v-btn>
                      <v-btn
                        fab
                        x-small
                        depressed
                        color="error"
                        @click="revomeDelivery(index)">
                        <v-icon color="white">mdi-delete</v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-flex>

    <v-dialog @keydown.esc="deliveryDialog=false" v-model="deliveryDialog" persistent max-width="400px">
      <v-card>
        <v-card-title>
          <span class="headline">Agregar dirección de entrega</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="deliveryForm">
            <v-container grid-list-xl>
              <v-layout wrap>
                <v-flex class="pa-0" xs12 md12>
                  <v-text-field
                    v-model="formDelivery.address"
                    label="Dirección"
                    placeholder="Mimosa Dorada #980, 28983 Ciudad de México"
                    :rules="rules.deliveryAddress"
                    required>
                  </v-text-field>
                </v-flex>
                <v-flex class="pa-0" xs12 md12>
                  <v-text-field
                    v-model="formDelivery.schedule"
                    label="Horario"
                    :rules="rules.schedule"
                    placeholder="10:00 AM - 21:00 PM"
                    required>
                  </v-text-field>
                </v-flex>
                <v-flex class="pa-0" xs12 md12>
                  <v-text-field
                    v-model="formDelivery.receiver"
                    label="Nombre de quien recibe"
                    placeholder="Manuel V."
                    :rules="rules.receiver"
                    required>
                  </v-text-field>
                </v-flex>
                <v-flex class="pa-0" xs12 md12>
                   <v-checkbox
                    v-model="formDelivery.isDefault"
                    label="Seleccionar dirección por default."
                  ></v-checkbox>
                </v-flex>
                <v-flex class="pa-0" xs12 md12>
                  <v-textarea
                    v-model="formDelivery.comments"
                    label="Comentarios"
                    solo
                    required>
                  </v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black darken-1" text @click="onCloseDeliveryDialog">Cancelar</v-btn>
          <v-btn color="black darken-1" text @click="submitDelivery">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

  </v-layout>
</template>

<script>
import countrycodes from '@/lib/countrycodes'
// import AddPhoneNumber from '@/components/modals/AddPhoneNumber'
// import VerifyNumber from '@/components/modals/VerifyNumber'
// import DeleteNumber from '@/components/modals/DeleteNumber'

export default {
  name: 'Restaurant',
  components: {
    // AddPhoneNumber,
    // VerifyNumber,
    // DeleteNumber
  },
  data () {
    return {
      deliveryDialog: false,
      enableSaveLocation: false,
      map: null,
      geocoder: null,
      marker: null,
      lat: 0,
      lng: 0,
      ubication: null,
      section: 'Configuración',
      overlay: false,
      countrycodes,
      restaurantInformation: {
        picture: null
      },
      taxInformationFormValid: false,
      formDelivery: {
        address: null,
        schedule: null,
        comments: null,
        receiver: null,
        isDefault: false
      },
      form: {
        restaurantInformation: {
          valid: false,
          name: this.$store.state.currentRestaurant.data.name,
          picture: {
            name: null,
            location: null
          },
          nip: '',
          address: {
            street: null,
            interior: null,
            exterior: null,
            neighborhood: null,
            city: null,
            state: null,
            zipCode: null,
            geolocation: {
              type: null,
              coordinates: []
            }
          },
          deliveryAddresses: []
        },
        taxInformation: {
          taxName: '',
          taxId: '',
          taxRegistrationNumber: '',
          address: {
            street: '',
            exteriorNumber: '',
            interiorNumber: '',
            neighborhood: '',
            zipCode: '',
            locality: '',
            municipality: '',
            state: '',
            country: ''
          },
          email: '',
          wansoftId: '',
          certificate: '',
          privateKey: '',
          privateKeyPassword: null,
          certificateFile: null,
          privateKeyFile: null,
          firmPrivateKeyPassword: null,
          firmCertificateFile: null,
          firmPrivateKeyFile: null,
          fiscalRegime: '',
          csdId: ''
        }
      },
      rules: {
        email: [
          v => !!v || this.$t('validations.email.required'),
          v => /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(v) || this.$t('validations.email.valid')
        ],
        name: [
          v => !!v || 'Name is required',
          v => /^[a-zA-Z0-9 ]*$/g.test(v) || 'Only alphabetic characters and numbers are allowed'
        ],
        nip: [v => !!v || 'NIP is required'],
        street: [v => !!v || 'Street is required'],
        exteriorNumber: [v => !!v || 'Exterior number is required'],
        interiorNumber: [v => !!v || 'Interior number is required'],
        neighborhood: [v => !!v || 'Neighborhood is required'],
        zipCode: [
          v => !!v || 'Zipcode is required',
          v => v.length === 5 || 'Zipcode must be 5 digits',
          v => /^[a-zA-Z0-9 ]*$/g.test(v) || 'Only alphabetic characters and numbers are allowed'
        ],
        locality: [v => !!v || 'Locality is required'],
        municipality: [v => !!v || 'Municipality is required'],
        state: [v => !!v || 'State is required'],
        country: [v => !!v || 'Country is required'],
        wansoftId: [v => !!v || 'WansoftId is required'],
        certificate: [v => !!v || 'Certificate is required'],
        privateKey: [v => !!v || 'Privatekey is required'],
        privateKeyPassword: [v => !!v || 'Privatekey password is required'],
        taxName: [
          v => !!v || 'Tax name is required',
          v => /^[a-zA-Z0-9 ]*$/g.test(v) || 'Only alphabetic characters and numbers are allowed',
          v => {
            const forbiddenWords = ['SA', 'SAPI', 'CV', 'SRL', 'SNC', 'SCS', 'SCA', 'SAS']
            const regex = new RegExp(`^(?!.*\\b(${forbiddenWords.join('|')})\\b)[a-zA-Z0-9 ]+$`)
            return regex.test(v) || 'The tax name should not contail the fiscal regime'
          }
        ],
        taxRegime: [v => !!v || 'Tax regime is required'],
        taxId: [
          v => !!v || 'Tax Id is required',
          v => /^[a-zA-Z0-9]*$/g.test(v) || 'Only alphabetic characters and numbers are allowed'
        ],
        taxRegistrationNumber: [v => !!v || 'Tax registration number is required'],
        deliveryAddress: [v => !!v || 'Address is required'],
        schedule: [v => !!v || 'Schedule is required'],
        receiver: [v => !!v || 'Receiver is required']
      },
      showPassword: false,
      showNip: false,
      taxRegimes: [
        { satId: '601', name: 'General de Ley Personas Morales' },
        { satId: '603', name: 'Personas Morales con Fines no Lucrativos' },
        { satId: '605', name: 'Sueldos y Salarios e Ingresos Asimilados a Salarios' },
        { satId: '606', name: 'Arrendamiento' },
        { satId: '607', name: 'Régimen de Enajenación o Adquisición de Bienes' },
        { satId: '608', name: 'Demás ingresos' },
        { satId: '609', name: 'Consolidación' },
        { satId: '610', name: 'Residentes en el Extranjero sin Establecimiento Permanente en México' },
        { satId: '611', name: 'Ingresos por Dividendos (socios y accionistas)' },
        { satId: '612', name: 'Personas Físicas con Actividades Empresariales y Profesionales' },
        { satId: '614', name: 'Ingresos por intereses' },
        { satId: '615', name: 'Régimen de los ingresos por obtención de premios' },
        { satId: '616', name: 'Sin obligaciones fiscales' },
        { satId: '620', name: 'Sociedades Cooperativas de Producción que optan por diferir sus ingresos' },
        { satId: '621', name: 'Incorporación Fiscal' },
        { satId: '622', name: 'Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras Sí Sí' },
        { satId: '623', name: 'Opcional para Grupos de Sociedades' },
        { satId: '624', name: 'Coordinados' },
        { satId: '625', name: 'Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas' },
        { satId: '626', name: 'Régimen Simplificado de Confianza' },
        { satId: '628', name: 'Hidrocarburos' },
        { satId: '629', name: 'De los Regímenes Fiscales Preferentes y de las Empresas Multinacionales' },
        { satId: '630', name: 'Enajenación de acciones en bolsa de valores' }
      ],
      alert: {
        active: false,
        color: '',
        message: ''
      },
      social: {
        facebook: {
          color: 'rgb(23 119 242)',
          successMessage: 'Ya estás conectado a Facebook',
          errorMessage: 'Hubo un error al intentar conectarse a Facebook'
        },
        foursquare: {
          color: '#F94877',
          successMessage: 'Ya estás conectado a Foursquare',
          errorMessage: 'Hubo un error al intentar conectarse a Facebook'
        }
      },
      phoneSelected: {},
      defaultAddress: {}
    }
  },
  watch: {
    'restaurantInformation.picture': async function (val) {
      if (val) {
        this.overlay = true
        try {
          const form = new FormData()
          form.append('pictureFile', this.restaurantInformation.picture)
          await this.$api.post(`/v1/restaurants/${this.$store.state.currentRestaurant.data._id}/picture`, form)
          await this.get()
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
        this.overlay = false
      }
    }
  },
  computed: {
    query () {
      const query = Object.entries(this.$route.query)
      return query.length ? query[0] : null
    },
    restaurant () {
      return this.$store.state.currentRestaurant.data
    },
    restaurantPermissions () {
      return this.$store.state.login.permissions['settings'].components['restaurant'].actions
    }
  },
  async mounted () {
    this.checkSocialconnection(this.query)
    await this.get()
    this.initMap()
  },
  methods: {
    async revomeDelivery (index) {
      this.overlay = true
      try {
        const restaurantInformation = this.form.restaurantInformation
        restaurantInformation.deliveryAddresses.splice(index, 1)
        await this.$api.post(`/v1/restaurants/${this.$store.state.currentRestaurant.data._id}/delivery-address`, restaurantInformation)
        await this.get()
        this.onCloseDeliveryDialog()
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    updateDelivery (item) {
      this.formDelivery.address = item.address
      this.formDelivery.schedule = item.schedule
      this.formDelivery.comments = item.comments
      this.formDelivery.receiver = item.receiver
      this.formDelivery.isDefault = item.isDefault
      this.formDelivery._id = item._id
      this.deliveryDialog = true
    },
    changeDefaultAddress (isDefault) {
      if (isDefault) {
        const addressDefault = this.form.restaurantInformation.deliveryAddresses.find(x => x.isDefault)
        if (addressDefault) addressDefault.isDefault = false
      }
    },
    async submitDelivery () {
      if (this.$refs.deliveryForm.validate()) {
        this.overlay = true
        try {
          const restaurantInformation = this.form.restaurantInformation
          if (this.formDelivery._id) {
            this.changeDefaultAddress(this.formDelivery.isDefault)
            const deliveryAddresses = restaurantInformation.deliveryAddresses.find(x => x._id === this.formDelivery._id)
            deliveryAddresses.address = this.formDelivery.address
            deliveryAddresses.schedule = this.formDelivery.schedule
            deliveryAddresses.comments = this.formDelivery.comments
            deliveryAddresses.receiver = this.formDelivery.receiver
            deliveryAddresses.isDefault = this.formDelivery.isDefault
          } else {
            this.changeDefaultAddress(this.formDelivery.isDefault)
            restaurantInformation.deliveryAddresses.push(this.formDelivery)
          }
          await this.$api.post(`/v1/restaurants/${this.$store.state.currentRestaurant.data._id}/delivery-address`, restaurantInformation)
          await this.get()
          this.onCloseDeliveryDialog()
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
        this.overlay = false
      }
    },
    onCloseDeliveryDialog () {
      this.formDelivery.address = null
      this.formDelivery.schedule = null
      this.formDelivery.comments = null
      this.formDelivery.receiver = null
      this.formDelivery.isDefault = false
      this.formDelivery._id = null
      this.deliveryDialog = false
    },
    openDeleteNumber (phone) {
      this.phoneSelected = phone
      this.$refs.deleteNumber.open()
    },
    openVerifyNumberModal (phone) {
      this.phoneSelected = phone
      this.$refs.verifyNumber.open()
    },
    openAddPhoneNumberModal () {
      this.$refs.addPhoneNumber.open()
    },
    checkSocialconnection (query) {
      if (query) {
        this.alert.active = true
        this.alert.color = query[0] === 'loged-from'
          ? this.social[query[1]]['color']
          : 'red'
        this.alert.message = query[0] === 'loged-from'
          ? this.social[query[1]].successMessage
          : this.social[query[1]].errorMessage
      }
    },
    connectSocialNetwork: function (socialNetwork) {
      return `${process.env.VUE_APP_API_URL}/v1/restaurants/integrations/${socialNetwork}/auth?restaurant=${this.$store.state.currentRestaurant.data._id}&access_token=${this.$store.state.login.token}`
    },
    searchCode (item, queryText, itemText) {
      const name = item.name.toLowerCase()
      const searchText = queryText.toLowerCase()
      return name.indexOf(searchText) >= 0
    },
    async saveRestaurantInfo () {
      if (this.$refs.restaurantInfoForm.validate()) {
        this.overlay = true
        try {
          const restaurantInformation = this.form.restaurantInformation
          restaurantInformation.picture = this.form.restaurantInformation.picture && this.form.restaurantInformation.picture.location
            ? this.form.restaurantInformation.picture.location
            : ''
          await this.$api.post(`/v1/restaurants/${this.$store.state.currentRestaurant.data._id}`, restaurantInformation)
          await this.get()
          this.$toasted.show('Los datos se guardaron con éxito', { duration: 3000 })
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
        this.overlay = false
      }
    },
    async cancel () {
      await this.get()
      this.disabled = true
    },
    async saveTaxInformation () {
      this.$refs.taxInformationForm.validate()
      if (this.taxInformationFormValid) {
        this.overlay = true
        try {
          const form = new FormData()
          let taxInformation
          form.append('csdId', this.form.csdId)
          form.append('address', JSON.stringify(this.form.taxInformation.address))
          form.append('certificate', this.form.taxInformation.certificateFile)
          form.append('privateKey', this.form.taxInformation.privateKeyFile)
          form.append('fiscalRegime', this.form.taxInformation.fiscalRegime)
          form.append('firmPrivateKey', this.form.taxInformation.firmPrivateKeyFile)
          form.append('firmCertificate', this.form.taxInformation.firmCertificateFile)
          form.append('taxName', this.form.taxInformation.taxName)
          form.append('taxId', this.form.taxInformation.taxId)
          if (this.form.taxInformation.privateKeyPassword) {
            form.append('privateKeyPassword', this.form.taxInformation.privateKeyPassword)
          }
          if (this.form.taxInformation.firmPrivateKeyPassword) {
            form.append('firmPrivateKeyPassword', this.form.taxInformation.firmPrivateKeyPassword)
          }
          if (!this.form._id) {
            taxInformation = await this.$api.post(`/v1/restaurants/${this.$store.state.currentRestaurant.data._id}/settings`, form)
          } else {
            taxInformation = await this.$api.put(`/v1/restaurants/${this.$store.state.currentRestaurant.data._id}/settings`, form)
          }
          const restaurant = this.$store.state.currentRestaurant.data
          restaurant.taxInformation = taxInformation
          this.$store.commit('setRestaurant', restaurant)
          this.$toasted.show('Los datos se guardaron con éxito', { duration: 3000 })
          await this.cancel()
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
        this.overlay = false
      }
    },
    async get () {
      this.overlay = true
      try {
        const response = await this.$api.get(`/v1/restaurants/${this.$store.state.currentRestaurant.data._id}/settings`)
        const restaurant = await this.$api.get(`/v1/restaurants/${this.$store.state.currentRestaurant.data._id}`)
        this.form.restaurantInformation.address = restaurant.address || {}
        if (restaurant.address && restaurant.address.geolocation && restaurant.address.geolocation.coordinates.length > 0) {
          this.defaultAddress = {
            type: restaurant.address.geolocation.type,
            coordinates: {
              lat: restaurant.address.geolocation.coordinates[0],
              lng: restaurant.address.geolocation.coordinates[1]
            }
          }
        } else {
          this.defaultAddress = {
            type: 'Point',
            coordinates: { lat: 23.634501, lng: -102.552784 }
          }
        }
        this.form.restaurantInformation.name = restaurant.name
        this.form.restaurantInformation.picture = restaurant.picture
        this.form.restaurantInformation.nip = restaurant.nip
        this.form.restaurantInformation.deliveryAddresses = restaurant.deliveryAddresses
        await this.$store.commit('currentRestaurant/set', restaurant)
        const restaurantState = this.$store.state.currentRestaurant.data
        restaurantState.phoneList = restaurant.phoneList
        if (response) {
          this.form._id = response._id
          this.form.taxInformation.taxName = response.taxName
          this.form.taxInformation.taxId = response.taxId
          this.form.taxInformation.address.zipCode = response.address.zipCode
          this.form.taxInformation.address.country = response.address.country
          this.form.taxInformation.certificate = response.certificate
          this.form.taxInformation.privateKey = response.privateKey
          this.form.taxInformation.privateKeyPassword = response.privateKeyPassword
          this.form.taxInformation.firmPrivateKeyPassword = response.firmPrivateKeyPassword
          this.form.taxInformation.fiscalRegime = response.fiscalRegime
          restaurantState.taxInformation = response
          this.$store.commit('currentRestaurant/taxInformation/set', restaurantState.taxInformation)
        }
        this.$store.commit('setRestaurant', restaurantState)
      } catch (error) {
        if (error.status !== 404) { this.$toasted.show(error.message, { duration: 3000 }) }
      }
      this.overlay = false
    },
    initMap () {
      if (this.form.restaurantInformation.address.geolocation && this.form.restaurantInformation.address.geolocation.coordinates.length) {
        this.map = new window.google.maps.Map(this.$refs.map, {
          zoom: 19,
          center: this.defaultAddress.coordinates
        })
        this.marker = new window.google.maps.Marker({
          map: this.map,
          draggable: true,
          position: this.defaultAddress.coordinates
        })
      } else {
        this.map = new window.google.maps.Map(this.$refs.map, {
          zoom: 6,
          center: this.defaultAddress.coordinates
        })
        this.marker = new window.google.maps.Marker({
          map: this.map,
          draggable: true
        })
      }
    },
    geocodeAddress () {
      this.marker.setMap(null)
      this.geocoder = new window.google.maps.Geocoder()
      const address = `${this.form.restaurantInformation.address.exterior}, ${this.form.restaurantInformation.address.street}, ${this.form.restaurantInformation.address.neighborhood}, ${this.form.restaurantInformation.address.city}, ${this.form.restaurantInformation.address.state}`
      this.geocoder.geocode({ address: address }, (results, status) => {
        if (status === 'OK') {
          this.map.setCenter(results[0].geometry.location)
          this.map.setZoom(19)
          this.marker = new window.google.maps.Marker({
            map: this.map,
            draggable: true,
            position: results[0].geometry.location
          })
          this.enableSaveLocation = true
        } else {
          this.$toasted.show(('La dirección no fue encontrada, por favor úbicala: '), { duration: 3000 })
          this.marker.setMap(null)
          const address2 = `${this.form.restaurantInformation.address.zipCode}`
          this.geocoder.geocode({ address: address2 }, (results, status) => {
            if (status === 'OK') {
              this.map.setCenter(results[0].geometry.location)
              this.map.setZoom(19)
              this.marker = new window.google.maps.Marker({
                map: this.map,
                draggable: true,
                position: results[0].geometry.location
              })
              this.enableSaveLocation = true
            }
          })
        }
      })
    },
    async updateMarker () {
      const coordinates = []
      coordinates.push(this.marker.getPosition().lat(), this.marker.getPosition().lng())
      this.form.restaurantInformation.address.geolocation.type = 'Point'
      this.form.restaurantInformation.address.geolocation.coordinates = coordinates
      await this.saveRestaurantInfo()
    },
    deleteAccents (str) {
      return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    }
  }
}
</script>
